<div class="app-container" [class.blurred]="showInstagramWarning()">
  <ng-container *transloco="let t">
    <router-outlet></router-outlet>
  </ng-container>
</div>

@if (showInstagramWarning()) {
  <pxw-instagram-warning />
}